

// rem等比适配配置文件
// 基准大小
const baseSize = 16;

// var flag = true;
// 设置 rem 函数

function setRem() {
  var scale = document.documentElement.clientWidth / 1920
  var aa = document.documentElement.clientWidth;
  if (aa > 1920) {
    window.localStorage.setItem("flag", false);
    document.documentElement.style.fontSize = baseSize + 'px';
  } else if(aa > 520 && aa <= 1920 ){
    // 当前页面屏幕分辨率相对于 1920宽的缩放比例，可根据自己需要修改
    window.localStorage.setItem("flag", true);
    // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
  }else {
    // window.localStorage.setItem("flag", true);
    // document.documentElement.style.fontSize = baseSize * Math.min(scale, 0.75) + 'px';
  }
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.addEventListener("resize",() => {
  setRem();
  // var usName = localStorage.getItem("flag")
  // if (usName) {
  //   window.location.reload();
  // }
})